namespace TabAurous.Administration {
    export interface ConfigurationForm {
        Code: Serenity.IntegerEditor;
        Name: Serenity.StringEditor;
        Description: Serenity.StringEditor;
        Type: Serenity.StringEditor;
        Value: Serenity.StringEditor;
    }

    export class ConfigurationForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.Configuration';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ConfigurationForm.init)  {
                ConfigurationForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;

                Q.initFormType(ConfigurationForm, [
                    'Code', w0,
                    'Name', w1,
                    'Description', w1,
                    'Type', w1,
                    'Value', w1
                ]);
            }
        }
    }
}
